// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';
import {getClaimRoutes} from '../../../shared/components/create-claim-modal/get-claim-routes-service';
import {routerActions} from 'react-router-redux';

export const updateCreateClaimModalVisibility = (isOpen, pin = '') =>

    dispatch => {

        addRemoveModalClass(isOpen);

        dispatch({
            isOpen,
            pin,
            type: actions.UPDATE_ALL_CLAIMS_CREATE_CLAIM_MODAL_VISIBILITY
        });

    };

export const onCreateClaim = (key, pin) =>

    dispatch => {

        document.body.classList.remove('warranty-modal-is-open');
        dispatch(routerActions.push(getClaimRoutes(key, pin)));

    };



// WEBPACK FOOTER //
// ./src/claim/all-claims/action-creators/create-claim-modal-visibility.js